<template>
  <div>
    <v-autocomplete v-model="selected" :label="label" :items="items" item-value="id"
      :item-text="locationLabel" return-object outlined dense clearable no-filter
      :search-input.sync="search" :loading="loading" :error-messages="error"
      :no-data-text="loading ? 'Loading locations�' : 'No locations found. Search or add one.'"
      @change="choose" @focus="refresh">
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title>{{ item.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ item.path }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
    <div class="d-flex flex-wrap mb-3">
      <v-btn small text color="primary" @click="editEntry = {}; editing = true">Add location</v-btn>
      <v-btn small text :disabled="!selected" @click="editEntry = selected; editing = true">
        Edit saved location
      </v-btn>
    </div>
    <location-editor v-if="editing" :location="editEntry" :kind="kind"
      @close="editing = false" @saved="saved" />
  </div>
</template>

<script>
import { listLocations, locationEvents, featureError } from '@/services/loadTools';
import LocationEditor from './LocationEditor.vue';

export default {
  name: 'LocationPicker',
  components: { LocationEditor },
  props: {
    kind: { type: String, required: true },
    label: { type: String, required: true },
    resetKey: { type: Number, default: 0 },
  },
  data() {
    return {
      selected: null,
      search: '',
      items: [],
      loading: false,
      error: '',
      editing: false,
      editEntry: {},
      timer: null,
      request: 0,
    };
  },
  watch: {
    search() {
      clearTimeout(this.timer);
      this.request += 1;
      this.timer = setTimeout(this.refresh, 250);
    },
    resetKey() { this.selected = null; this.search = ''; },
  },
  created() {
    this.refresh();
    locationEvents.$on('changed', this.refresh);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    this.request += 1;
    locationEvents.$off('changed', this.refresh);
  },
  methods: {
    locationLabel(item) { return `${item.name} � ${item.path}`; },
    async refresh() {
      this.request += 1;
      const { request } = this;
      this.loading = true;
      this.error = '';
      const search = this.selected && this.search === this.locationLabel(this.selected)
        ? '' : this.search || '';
      try {
        const result = await listLocations({ kind: this.kind, search, take: 100 });
        if (request !== this.request) return;
        this.items = result.data;
        if (this.selected && !this.items.some((item) => item.id === this.selected.id)) {
          this.items = [this.selected, ...this.items];
        }
      } catch (error) {
        if (request === this.request) {
          this.items = [];
          this.error = featureError(error, 'Cannot load locations. Focus this field to retry.');
        }
      } finally {
        if (request === this.request) this.loading = false;
      }
    },
    choose(location) {
      // Copy reusable fields. Clearing the picker never erases a drafted stop.
      if (location) {
        this.$emit('select', {
          name: location.name,
          path: location.path,
          contact: location.contact,
          notes: location.notes,
        });
      }
    },
    saved(location) {
      this.editing = false;
      this.items = [location, ...this.items.filter((item) => item.id !== location.id)];
      this.selected = location;
      this.choose(location);
    },
  },
};
</script>
